export default {
  SEARCH_CATALOG_KUSPIT_SOURCE_QUERY: Symbol.for('SEARCH_CATALOG_KUSPIT_SOURCE_QUERY'),
  CATALOG_KUSPIT_SOURCE_REPOSITORY: Symbol.for('CATALOG_KUSPIT_SOURCE_REPOSITORY'),
  CATALOG_KUSPIT_SOURCE_STATE_MANAGER: Symbol.for('CATALOG_KUSPIT_SOURCE_STATE_MANAGER'),
};
